import queryString from 'query-string';

import type { ILocationSearchVM } from '~/types';

import { api, type IFetchApiProps } from './api';
import type { ICoordinateVM } from '~/types/viewModels/coordinateVM';

export const QK_FETCH_COORDINATES = 'qk_fetchCoordinates';
export const QK_SEARCH_LOCATIONS = 'qk_searchLocations';

export interface ISearchLocationsRequest extends IFetchApiProps {
  query: string;
}

export interface ISearchCoordinateRequest extends IFetchApiProps {
  query: string;
}

export interface IFetchCoordinatesRequest extends IFetchApiProps {
  placeId: string;
}

function searchLocations({
  query,
  signal,
}: ISearchLocationsRequest): Promise<ILocationSearchVM[]> {
  return api.get(
    queryString.stringifyUrl(
      {
        url: '/locations/search',
        query: {
          query,
        },
      },
      {
        arrayFormat: 'bracket',
      },
    ),
    {
      signal,
    },
  );
}

function fetchCoordinatesByPlaceId({
  placeId,
  signal,
}: IFetchCoordinatesRequest): Promise<ICoordinateVM> {
  return api.get(
    queryString.stringifyUrl(
      {
        url: '/locations/fetch_coordinates',
        query: {
          place_id: placeId,
        },
      },
      {
        arrayFormat: 'bracket',
      },
    ),
    {
      signal,
    },
  );
}

export const locationApi = {
  searchLocations,
  fetchCoordinatesByPlaceId,
} as const;
